module.exports = __webpack_public_path__ + "ch.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ch.svg
// module id = 487
// module chunks = 0